import { Flex } from "@mantine/core";
import ColoredBadge from "./ColoredBadge";

export default function TagGroup({
  tags,
  vertical,
  size = "md",
  wrap = "wrap",
  justify = "flex-start",
  ...other
}) {
  return (
    tags && (
      <Flex wrap={wrap} gap={size} direction={vertical ? "column" : "row"} justify={justify}>
        {tags.map((p, idx) => (
          <ColoredBadge size={size} {...other} key={"tag" + p + idx} name={p} />
        ))}
      </Flex>
    ) 
  );
}
